/**
 * Consent policy version. Bumping this invalidates every previously stored
 * choice: the banner re-appears and the Analitici toggle restarts OFF, even for
 * users who had accepted (new version = new consent, never pre-checked — AC 7).
 */
export const CONSENT_VERSION = "2026-07";

/** localStorage key holding the client-side consent record (never a `ph_*` cookie). */
export const CONSENT_STORAGE_KEY = "cookie-consent";

/**
 * QA override query param. When `?cookie_banner=1` is present the CMP surfaces
 * are forced on even where `VITE_POSTHOG_ENABLED=false` (dev/staging), so the
 * flow can be tested. The override is not persisted — it lasts for the session.
 */
export const CONSENT_DEBUG_QUERY_PARAM = "cookie_banner";

/**
 * Existing external cookie policy on the marketing site. The banner and footer
 * link to it; there is no in-app policy route (SPEC Non-Goals, D5).
 */
export const COOKIE_POLICY_URL = "https://www.sevedemo.com/cookie-policy/";

/**
 * External legal pages on the marketing site — the maintained, up-to-date
 * versions (same URLs the signup consent checkbox already links). The global
 * footer points here instead of the stale in-app `/legal/policies` route.
 */
export const TERMS_URL = "https://www.sevedemo.com/termini/";
export const PRIVACY_URL = "https://www.sevedemo.com/privacy-policy/";
